import gcAmazon from '../assets/giftCardImages/Amazon.png';
import gcAmc from '../assets/giftCardImages/amc.jpeg';
import gcApplebees from '../assets/giftCardImages/Applebees.png';
import gcBarnesNoble from '../assets/giftCardImages/BarnesNoble.png';
import gcBestBuy from '../assets/giftCardImages/BestBuy.png';
import gcBurgerKing from '../assets/giftCardImages/BurgerKing.png';
import gcChipotle from '../assets/giftCardImages/Chipotle.png';
import gcColumbia from '../assets/giftCardImages/Columbia.jpeg';
import gcCVS from '../assets/giftCardImages/CVS.png';
import gcDelta from '../assets/giftCardImages/Delta.png';
import gcDominos from '../assets/giftCardImages/Dominos.png';
import gcExpress from '../assets/giftCardImages/Express.jpeg';
import gcGameStop from '../assets/giftCardImages/GameStop.jpeg';
import gcGapBrands from '../assets/giftCardImages/GapBrands.jpeg';
import gcJCPenney from '../assets/giftCardImages/JCPenney.png';
import gcLowes from '../assets/giftCardImages/Lowes.png';
import gcPaneraBread from '../assets/giftCardImages/PaneraBread.png';
import gcPapaJohns from '../assets/giftCardImages/PapaJohns.jpeg';
import gcSubway from '../assets/giftCardImages/Subway.png';
import gcTarget from '../assets/giftCardImages/Target.png';
import gcWalmart from '../assets/giftCardImages/Walmart.png';
import gcAdvanceAutoParts from '../assets/giftCardImages/AdvanceAutoParts.png';
import gcAeropostale from '../assets/giftCardImages/Aeropostale.png';
import gcAmericanEagle from '../assets/giftCardImages/American Eagle.jpeg';
import gcApple from '../assets/giftCardImages/Apple.png';
import gcBathBodyWorks from '../assets/giftCardImages/Bath and Body Works.png';
import gcBenihana from '../assets/giftCardImages/Benihana.png';
import gcBloominBrands from '../assets/giftCardImages/Bloomin Brands.png';
import gcBrinkerBrandsChilis from '../assets/giftCardImages/Brinker Brands.png';
import gcBucaDiBeppo from '../assets/giftCardImages/Buca di Beppo.jpeg';
import gcBuffaloWildWings from '../assets/giftCardImages/Buffalo Wild Wings.jpeg';
import gcCaliforniaPizzaKitchen from '../assets/giftCardImages/CA Pizza Kitchen.png';
import gcCabelas from '../assets/giftCardImages/Cabelas.png';
import gcCheesecakeFactory from '../assets/giftCardImages/The Cheesecake Factory.png';
import gcChevron from '../assets/giftCardImages/Chevron-Texaco.png';
import gcCinemark from '../assets/giftCardImages/Cinemark.png';
import gcCoffeeBeanTeaLeaf from '../assets/giftCardImages/The Coffee Bean _ Tea Leaf.png';
import gcColdStone from '../assets/giftCardImages/Cold Stone Creamery.png';
import gcContainerStore from '../assets/giftCardImages/TheContainerStoreXL.png';
import gcCrackerBarrel from '../assets/giftCardImages/Cracker Barrel.jpeg';
import gcCrateBarrel from '../assets/giftCardImages/Crate_BarrelXL.png';
import gcDardenBrands from '../assets/giftCardImages/Darden Brands.png';
import gcElementsMassage from '../assets/giftCardImages/Elements Massage.png';
import gcFamousFootwear from '../assets/giftCardImages/Famous Footwear.jpeg';
import gcGooglePlay from '../assets/giftCardImages/Google Play.png';
import gcGoPlayGolf from '../assets/giftCardImages/GoPlayGolf.png';
import gcHelloFresh from '../assets/giftCardImages/HelloFresh.png';
import gcHomeDepot from '../assets/giftCardImages/The-Home-Depot_v02.png';
import gcHotelsCom from '../assets/giftCardImages/Hotels.com.png';
import gcIhop from '../assets/giftCardImages/IHOP.png';
import gcKohls from '../assets/giftCardImages/KohlsXL.png';
import gcKrispyKreme from '../assets/giftCardImages/Krispy Kreme.png';
import gcKroger from '../assets/giftCardImages/Kroger.png';
import gcLandsEnd from '../assets/giftCardImages/Lands End.jpeg';
import gcLegalSeaFoods from '../assets/giftCardImages/Legal Sea Foods.png';
import gcLuluLemon from '../assets/giftCardImages/lululemon.png';
import gcMacaroniGrill from '../assets/giftCardImages/Macaroni Grill.png';
import gcMacys from '../assets/giftCardImages/Macys.png';
import gcMainEvent from '../assets/giftCardImages/MainEvent.png';
import gcMichaels from '../assets/giftCardImages/Michaels.png';
import gcNike from '../assets/giftCardImages/Nike.png';
import gcNordstromRack from '../assets/giftCardImages/Nordstrom Rack.png';
import gcOCharleys from '../assets/giftCardImages/OCharleys.png';
import gcOmahaSteak from '../assets/giftCardImages/omahasteaks.jpeg';
import gcPacsun from '../assets/giftCardImages/Pacsun.png';
import gcPetco from '../assets/giftCardImages/Petco.png';
import gcPetsmart from '../assets/giftCardImages/Petsmart.png';
import gcPotteryBarn from '../assets/giftCardImages/Pottery Barn.png';
import gcQuiznos from '../assets/giftCardImages/Quiznos.png';
import gcRedLobster from '../assets/giftCardImages/Red Lobster.png';
import gcRedRobin from '../assets/giftCardImages/RedRobin.png';
import gcRegal from '../assets/giftCardImages/Regal.png';
import gcREI from '../assets/giftCardImages/REI.png';
import gcSouthwestAirlines from '../assets/giftCardImages/Southwest Airlines.png';
import gcSpaFinder from '../assets/giftCardImages/Spafinder.png';
import gcStaples from '../assets/giftCardImages/StaplesXL.png';
import gcStarbucks from '../assets/giftCardImages/Starbucks.png';
import gcSteakNShake from '../assets/giftCardImages/Steak n Shake.png';
import gcSunglassHut from '../assets/giftCardImages/sunglass hut.jpeg';
import gcTexasRoadhouse from '../assets/giftCardImages/Texas Roadhouse.png';
import gcTGIFridays from '../assets/giftCardImages/TGIFridays.png';
import gcTJXBrands from '../assets/giftCardImages/TJMaxBrands.png';
import gcTopGolf from '../assets/giftCardImages/TopGolf.png';
import gcUlta from '../assets/giftCardImages/Ulta.png';
import gcUnderArmour from '../assets/giftCardImages/Under Armour.png';
import gcWayFair from '../assets/giftCardImages/WayfairXL.png';
import gcWilliamsSonoma from '../assets/giftCardImages/WilliamsSonoma_Mark_Graham_WestElmXL.png';
import gcXbox from '../assets/giftCardImages/Xbox.png';
import gcYankeeCandle from '../assets/giftCardImages/Yankee Candle.png';

export default [
	{
		id: 25,
		image: gcAdvanceAutoParts,
		amount: 25,
		price: 20,
		company: 'Advance Auto Parts',
		category: 'shopping',
		sku: 'E30269',
		popularity: 48
	},
	{
		id: 26,
		image: gcAeropostale,
		amount: 25,
		price: 20,
		company: 'Aeropostale',
		category: 'shopping',
		sku: 'E30213',
		popularity: 77
	},
	{
		id: 1,
		image: gcAmazon,
		amount: 25,
		price: 20,
		company: 'Amazon',
		category: 'shopping',
		sku: 'E0255756',
		popularity: 100
	},
	{
		id: 2,
		image: gcAmc,
		amount: 25,
		price: 20,
		company: 'AMC',
		category: 'living',
		sku: 'E30326',
		popularity: 78
	},
	{
		id: 27,
		image: gcAmericanEagle,
		amount: 25,
		price: 20,
		company: 'American Eagle Outfitters',
		category: 'shopping',
		sku: 'E30212',
		popularity: 73
	},
	{
		id: 28,
		image: gcApple,
		amount: 25,
		price: 20,
		company: 'Apple',
		category: 'shopping',
		sku: 'E30287',
		popularity: 67
	},
	{
		id: 3,
		image: gcApplebees,
		amount: 25,
		price: 20,
		company: "Applebee's",
		category: 'dining',
		sku: 'E30214',
		popularity: 65
	},
	{
		id: 4,
		image: gcBarnesNoble,
		amount: 25,
		price: 20,
		company: 'Barnes & Noble',
		category: 'shopping',
		sku: 'E21506',
		popularity: 64
	},
	{
		id: 29,
		image: gcBathBodyWorks,
		amount: 25,
		price: 20,
		company: 'Bath & Body Works',
		category: 'shopping',
		sku: 'E30328',
		popularity: 77
	},
	{
		id: 30,
		image: gcBenihana,
		amount: 25,
		price: 20,
		company: 'Benihana',
		category: 'dining',
		sku: 'E30270',
		popularity: 70
	},
	{
		id: 5,
		image: gcBestBuy,
		amount: 25,
		price: 20,
		company: 'Best Buy',
		category: 'shopping',
		sku: 'E21512',
		popularity: 95
	},
	{
		id: 95,
		image: gcBloominBrands,
		amount: 25,
		price: 20,
		company: 'Bloomin Brands',
		category: 'dining',
		sku: 'E30246',
		popularity: 90
	},
	{
		id: 96,
		image: gcBrinkerBrandsChilis,
		amount: 25,
		price: 20,
		company: 'Brinker Brands',
		category: 'dining',
		sku: 'E30247',
		popularity: 1
	},
	{
		id: 32,
		image: gcBuffaloWildWings,
		amount: 25,
		price: 20,
		company: 'Buffalo Wild Wings',
		category: 'dining',
		sku: 'E30268',
		popularity: 68
	},
	{
		id: 31,
		image: gcBucaDiBeppo,
		amount: 25,
		price: 20,
		company: 'Buca di Beppo',
		category: 'dining',
		sku: 'E30216',
		popularity: 1
	},
	{
		id: 6,
		image: gcBurgerKing,
		amount: 25,
		price: 20,
		company: 'Burger King',
		category: 'dining',
		sku: 'E30217',
		popularity: 57
	},
	{
		id: 34,
		image: gcCabelas,
		amount: 25,
		price: 20,
		company: "Cabela's",
		category: 'shopping',
		sku: 'E30218',
		popularity: 1
	},
	{
		id: 33,
		image: gcCaliforniaPizzaKitchen,
		amount: 25,
		price: 20,
		company: 'California Pizza Kitchen',
		category: 'dining',
		sku: 'E30272',
		popularity: 82
	},
	{
		id: 75,
		image: gcCheesecakeFactory,
		amount: 25,
		price: 20,
		company: 'The Cheesecake Factory',
		category: 'dining',
		sku: 'E30282',
		popularity: 87
	},
	{
		id: 35,
		image: gcChevron,
		amount: 25,
		price: 20,
		company: 'Chevron-Texaco',
		category: 'shopping',
		sku: 'E30219',
		popularity: 69
	},
	{
		id: 7,
		image: gcChipotle,
		amount: 25,
		price: 20,
		company: 'Chipotle',
		category: 'dining',
		sku: 'E30220',
		popularity: 79
	},
	{
		id: 36,
		image: gcCinemark,
		amount: 25,
		price: 20,
		company: 'Cinemark Theaters',
		category: 'living',
		sku: 'E30293',
		popularity: 1
	},
	{
		id: 76,
		image: gcCoffeeBeanTeaLeaf,
		amount: 25,
		price: 20,
		company: 'The Coffee Bean & Tea Leaf',
		category: 'dining',
		sku: 'E30273',
		popularity: 1
	},
	{
		id: 38,
		image: gcColdStone,
		amount: 25,
		price: 20,
		company: 'Cold Stone Creamery',
		category: 'dining',
		sku: 'E30274',
		popularity: 1
	},
	{
		id: 100,
		image: gcContainerStore,
		amount: 25,
		price: 20,
		company: 'The Container Store',
		category: 'shopping',
		sku: 'E30243',
		popularity: 1
	},
	{
		id: 8,
		image: gcColumbia,
		amount: 25,
		price: 20,
		company: 'Columbia',
		category: 'shopping',
		sku: 'E30274',
		popularity: 76
	},
	{
		id: 85,
		image: gcCrackerBarrel,
		amount: 25,
		price: 20,
		company: 'Cracker Barrel',
		category: 'dining',
		sku: 'E30275',
		popularity: 66
	},
	{
		id: 39,
		image: gcCrateBarrel,
		amount: 25,
		price: 20,
		company: 'Crate & Barrel',
		category: 'shopping',
		sku: 'E30221',
		popularity: 1
	},
	{
		id: 9,
		image: gcCVS,
		amount: 25,
		price: 20,
		company: 'CVS',
		category: 'shopping',
		sku: 'E28142',
		popularity: 91
	},
	{
		id: 40,
		image: gcDardenBrands,
		amount: 25,
		price: 20,
		company: 'Darden Brands',
		category: 'shopping',
		sku: 'E30142',
		popularity: 94
	},
	{
		id: 10,
		image: gcDelta,
		amount: 25,
		price: 20,
		company: 'Delta Airlines',
		category: 'living',
		sku: 'E30294',
		popularity: 83
	},
	{
		id: 11,
		image: gcDominos,
		amount: 25,
		price: 20,
		company: 'Dominos',
		category: 'dining',
		sku: 'E30223',
		popularity: 85
	},
	{
		id: 41,
		image: gcElementsMassage,
		amount: 25,
		price: 20,
		company: 'Elements Massage',
		category: 'living',
		sku: 'E30321',
		popularity: 1
	},
	{
		id: 13,
		image: gcExpress,
		amount: 25,
		price: 20,
		company: 'Express',
		category: 'shopping',
		sku: 'E0255737',
		popularity: 72
	},
	{
		id: 42,
		image: gcFamousFootwear,
		amount: 25,
		price: 20,
		company: 'Famous Footwear',
		category: 'shopping',
		sku: 'E30329',
		popularity: 1
	},
	{
		id: 16,
		image: gcGameStop,
		amount: 25,
		price: 20,
		company: 'GameStop',
		category: 'shopping',
		sku: 'E30288',
		popularity: 1
	},
	{
		id: 17,
		image: gcGapBrands,
		amount: 25,
		price: 20,
		company: 'Gap Brands',
		category: 'shopping',
		sku: 'E30248',
		popularity: 86
	},
	{
		id: 44,
		image: gcGooglePlay,
		amount: 25,
		price: 20,
		company: 'Google Play',
		category: 'shopping',
		sku: 'E30289',
		popularity: 17
	},
	{
		id: 43,
		image: gcGoPlayGolf,
		amount: 25,
		price: 20,
		company: 'GoPlayGolf',
		category: 'living',
		sku: 'E30295',
		popularity: 1
	},
	{
		id: 45,
		image: gcHelloFresh,
		amount: 60,
		price: 48,
		company: 'HelloFresh',
		category: 'dining',
		sku: 'E30285',
		popularity: 1
	},
	{
		id: 77,
		image: gcHomeDepot,
		amount: 25,
		price: 20,
		company: 'The Home Depot',
		category: 'shopping',
		sku: 'E21509',
		popularity: 93
	},
	{
		id: 46,
		image: gcHotelsCom,
		amount: 25,
		price: 20,
		company: 'Hotels.com',
		category: 'living',
		sku: 'E30322',
		popularity: 76
	},
	{
		id: 47,
		image: gcIhop,
		amount: 25,
		price: 20,
		company: 'IHOP',
		category: 'dining',
		sku: 'E30226',
		popularity: 2
	},
	{
		id: 87,
		image: gcJCPenney,
		amount: 25,
		price: 20,
		company: 'JCPenney',
		category: 'shopping',
		sku: 'E0255739',
		popularity: 63
	},
	{
		id: 49,
		image: gcKohls,
		amount: 25,
		price: 20,
		company: 'Kohls',
		category: 'shopping',
		sku: 'E30228',
		popularity: 75
	},
	{
		id: 50,
		image: gcKrispyKreme,
		amount: 25,
		price: 20,
		company: 'Krispy Kreme',
		category: 'dining',
		sku: 'E30276',
		popularity: 1
	},
	{
		id: 51,
		image: gcKroger,
		amount: 25,
		price: 20,
		company: 'Kroger',
		category: 'shopping',
		sku: 'E30229',
		popularity: 97
	},
	{
		id: 52,
		image: gcLandsEnd,
		amount: 25,
		price: 20,
		company: "Lands' End",
		category: 'shopping',
		sku: 'E30231',
		popularity: 1
	},
	{
		id: 53,
		image: gcLegalSeaFoods,
		amount: 25,
		price: 20,
		company: 'Legal Sea Foods',
		category: 'dining',
		sku: 'E30277',
		popularity: 1
	},
	{
		id: 88,
		image: gcLowes,
		amount: 25,
		price: 20,
		company: "Lowe's",
		category: 'shopping',
		sku: 'E0255735',
		popularity: 89
	},
	{
		id: 106,
		image: gcLuluLemon,
		amount: 25,
		price: 20,
		company: 'Lululemon',
		category: 'shopping',
		sku: 'E30330',
		popularity: 1
	},
	{
		id: 98,
		image: gcMacaroniGrill,
		amount: 25,
		price: 20,
		company: 'Macaroni Grill',
		category: 'dining',
		sku: 'E30319',
		popularity: 1
	},
	{
		id: 54,
		image: gcMacys,
		amount: 25,
		price: 20,
		company: "Macy's",
		category: 'shopping',
		sku: 'E30232',
		popularity: 92
	},
	{
		id: 55,
		image: gcMainEvent,
		amount: 25,
		price: 20,
		company: 'Main Event',
		category: 'living',
		sku: 'E30300',
		popularity: 1
	},
	{
		id: 56,
		image: gcMichaels,
		amount: 25,
		price: 20,
		company: 'Michaels',
		category: 'shopping',
		sku: 'E30290',
		popularity: 1
	},
	{
		id: 101,
		image: gcNike,
		amount: 25,
		price: 20,
		company: 'Nike',
		category: 'shopping',
		sku: 'E30211',
		popularity: 1
	},
	{
		id: 57,
		image: gcNordstromRack,
		amount: 25,
		price: 20,
		company: 'Nordstrom Rack',
		category: 'shopping',
		sku: 'E30234',
		popularity: 14
	},
	{
		id: 58,
		image: gcOCharleys,
		amount: 25,
		price: 20,
		company: "O'Charleys",
		category: 'dining',
		sku: 'E30320',
		popularity: 44
	},
	{
		id: 59,
		image: gcOmahaSteak,
		amount: 25,
		price: 20,
		company: 'Omaha Steaks',
		category: 'dining',
		sku: 'E30284',
		popularity: 1
	},
	{
		id: 60,
		image: gcPacsun,
		amount: 25,
		price: 20,
		company: 'PacSun',
		category: 'shopping',
		sku: 'E30325',
		popularity: 1
	},
	{
		id: 89,
		image: gcPaneraBread,
		amount: 25,
		price: 20,
		company: 'Panera Bread',
		category: 'dining',
		sku: 'E0255740',
		popularity: 1
	},
	{
		id: 90,
		image: gcPapaJohns,
		amount: 25,
		price: 20,
		company: "Papa John's",
		category: 'dining',
		sku: 'E30235',
		popularity: 80
	},
	{
		id: 61,
		image: gcPetco,
		amount: 25,
		price: 20,
		company: 'Petco',
		category: 'shopping',
		sku: 'E30252',
		popularity: 74
	},
	{
		id: 62,
		image: gcPetsmart,
		amount: 25,
		price: 20,
		company: 'Petsmart',
		category: 'shopping',
		sku: 'E30253',
		popularity: 61
	},
	{
		id: 63,
		image: gcPotteryBarn,
		amount: 25,
		price: 20,
		company: 'Pottery Barn',
		category: 'shopping',
		sku: 'E0255738',
		popularity: 1
	},
	{
		id: 64,
		image: gcQuiznos,
		amount: 25,
		price: 20,
		company: 'Quiznos',
		category: 'dining',
		sku: 'E30279',
		popularity: 1
	},
	{
		id: 65,
		image: gcRedLobster,
		amount: 25,
		price: 20,
		company: 'Red Lobster',
		category: 'dining',
		sku: 'E30280',
		popularity: 93
	},
	{
		id: 66,
		image: gcRedRobin,
		amount: 25,
		price: 20,
		company: 'Red Robin',
		category: 'dining',
		sku: 'E30236',
		popularity: 1
	},
	{
		id: 67,
		image: gcRegal,
		amount: 25,
		price: 20,
		company: 'Regal Entertainment',
		category: 'living',
		sku: 'E30296',
		popularity: 1
	},
	{
		id: 68,
		image: gcREI,
		amount: 25,
		price: 20,
		company: 'REI',
		category: 'shopping',
		sku: 'E30297',
		popularity: 62
	},
	{
		id: 69,
		image: gcSouthwestAirlines,
		amount: 25,
		price: 20,
		company: 'Southwest Airlines',
		category: 'living',
		sku: 'E30323',
		popularity: 90
	},
	{
		id: 70,
		image: gcSpaFinder,
		amount: 25,
		price: 20,
		company: 'Spafinder',
		category: 'living',
		sku: 'E30298',
		popularity: 1
	},
	{
		id: 71,
		image: gcStaples,
		amount: 25,
		price: 20,
		company: 'Staples',
		category: 'shopping',
		sku: 'E30238',
		popularity: 84
	},
	{
		id: 72,
		image: gcStarbucks,
		amount: 25,
		price: 20,
		company: 'Starbucks',
		category: 'dining',
		sku: 'E30239',
		popularity: 96
	},
	{
		id: 73,
		image: gcSteakNShake,
		amount: 25,
		price: 20,
		company: 'Steak n Shake',
		category: 'dining',
		sku: 'E30281',
		popularity: 71
	},
	{
		id: 92,
		image: gcSubway,
		amount: 25,
		price: 20,
		company: 'Subway',
		category: 'dining',
		sku: 'E30240',
		popularity: 88
	},
	{
		id: 102,
		image: gcSunglassHut,
		amount: 25,
		price: 20,
		company: 'Sunglass Hut',
		category: 'shopping',
		sku: 'E30324',
		popularity: 1
	},
	{
		id: 93,
		image: gcTarget,
		amount: 25,
		price: 20,
		company: 'Target',
		category: 'shopping',
		sku: 'E21511',
		popularity: 98
	},
	{
		id: 74,
		image: gcTexasRoadhouse,
		amount: 25,
		price: 20,
		company: 'Texas Roadhouse',
		category: 'dining',
		sku: 'E30242',
		popularity: 83
	},
	{
		id: 103,
		image: gcTGIFridays,
		amount: 25,
		price: 20,
		company: 'TGI Fridays',
		category: 'dining',
		sku: 'E30225',
		popularity: 1
	},
	{
		id: 99,
		image: gcTJXBrands,
		amount: 25,
		price: 20,
		company: 'TJX Brands',
		category: 'shopping',
		sku: 'E0255742',
		popularity: 81
	},
	{
		id: 78,
		image: gcTopGolf,
		amount: 25,
		price: 20,
		company: 'TopGolf',
		category: 'living',
		sku: 'E30299',
		popularity: 1
	},
	{
		id: 104,
		image: gcUlta,
		amount: 25,
		price: 20,
		company: 'Ulta',
		category: 'shopping',
		sku: 'E30244',
		popularity: 1
	},
	{
		id: 79,
		image: gcUnderArmour,
		amount: 25,
		price: 20,
		company: 'Under Armour',
		category: 'shopping',
		sku: 'E30331',
		popularity: 5
	},
	{
		id: 94,
		image: gcWalmart,
		amount: 25,
		price: 20,
		company: 'Walmart',
		category: 'shopping',
		sku: 'E21517',
		popularity: 99
	},
	{
		id: 80,
		image: gcWayFair,
		amount: 25,
		price: 20,
		company: 'Wayfair',
		category: 'shopping',
		sku: 'E30210',
		popularity: 64
	},
	{
		id: 81,
		image: gcWilliamsSonoma,
		amount: 25,
		price: 20,
		company: 'Williams Sonoma',
		category: 'shopping',
		sku: 'E30251',
		popularity: 1
	},
	{
		id: 82,
		image: gcXbox,
		amount: 25,
		price: 20,
		company: 'Xbox',
		category: 'shopping',
		sku: 'E30291',
		popularity: 1
	},
	{
		id: 83,
		image: gcYankeeCandle,
		amount: 25,
		price: 20,
		company: 'Yankee Candle',
		category: 'shopping',
		sku: 'E30332',
		popularity: 1
	}
];
